import { createRequest } from '@paysera/http-client-common';
import httpClient from '%app/js/httpClient';
import { router } from '%app/js/common/services/router';

class CartClient {
    getCart({ token }) {
        const request = createRequest(
            'GET',
            router.generate('paysera_cart.order.get_cart', { token }),
        );

        return httpClient.performRequest(request);
    }

    updateReservation({ id, cartItem }) {
        const request = createRequest(
            'PUT',
            router.generate('paysera_cart.order_details.update_cart', { id }),
            cartItem,
        );

        return httpClient.performRequest(request);
    }

    reserve({ reservation, token }) {
        const request = createRequest(
            'POST',
            router.generate('paysera_cart.order.reserve', { token }),
            reservation,
        );

        return httpClient.performRequest(request);
    }

    discardReservation({ id }) {
        const request = createRequest(
            'DELETE',
            router.generate('paysera_cart.order_details.discard_reservation', { id }),
        );

        return httpClient.performRequest(request);
    }

    applyDiscount({ token, discountToken }) {
        const request = createRequest(
            'PUT',
            router.generate('paysera_cart.order.apply_discount', { token }),
            { token: discountToken },
        );

        return httpClient.performRequest(request);
    }
}

export default new CartClient();
